<app-page-header [title]="'Imprint'" [subtitle]="'Legal information for SampleStudio websites'"></app-page-header>
<div class="mb-6">
    <h3 class="text-2xl font-semibold mb-3">Provider</h3>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-sm mb-6">
        <p><strong>Mercedes-Benz AG</strong></p>
        <p>Mercedesstraße 120<br>70372 Stuttgart<br>Germany</p>
        <p>Phone: +49 7 11 17-0<br>Email: <a href="mailto:dialog@mercedes-benz.com">dialog&#64;mercedes-benz.com</a></p>

        <h4 class="text-lg font-semibold mt-3">Represented by:</h4>
        <p>Board of Management:</p>
        <p>Ola Källenius (Chairman), Jörg Burzer, Renata Jungo Brüngger, Sabine Kohleisen, Markus Schäfer, Britta
            Seeger, Hubertus Troska, Harald Wilhelm</p>
        <p>Chairman of the Supervisory Board: Martin Brudermüller</p>
        <p>Trade Register at Stuttgart District Court, No. HRB 762873</p>
        <p>VAT ID No.: DE 32 12 81 763</p>
    </div>

    <h3 class="text-2xl font-semibold mb-3">Other Advertising Companies</h3>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-sm mb-6">
        <h4 class="text-lg font-semibold">Mercedes-Benz Group AG</h4>
        <p>Mercedesstraße 120<br>70372 Stuttgart<br>Germany</p>
        <p>Phone: +49 711 17 0<br>Email: dialog&#64;mercedes-benz.com</p>
        <h4 class="text-lg font-semibold mt-3">Represented by:</h4>
        <p>Board of Management:</p>
        <p>Ola Källenius (Chairman), Jörg Burzer, Renata Jungo Brüngger, Sabine Kohleisen, Markus Schäfer, Britta
            Seeger, Hubertus Troska, Harald Wilhelm</p>
        <p>Chairman of the Supervisory Board: Martin Brudermüller</p>
        <p>Trade Register at Stuttgart District Court, No. HRB 19360</p>
        <p>VAT ID No.: DE 81 25 26 315</p>

        <h4 class="text-lg font-semibold mt-4">Mercedes-Benz Mobility AG</h4>
        <p>Siemensstr. 7<br>70469 Stuttgart<br>Germany</p>
        <p>Phone: +49 7 11 17-0<br>Email: mobility&#64;mercedes-benz.com</p>
        <h4 class="text-lg font-semibold mt-3">Represented by:</h4>
        <p>Board of Management:</p>
        <p>Franz Reiner (Chairman), Jörg Lamparter, Susann Mayhead, Peter Zieringer</p>
        <p>Chairman of the Supervisory Board: Harald Wilhelm</p>
        <p>Trade Register at Stuttgart District Court, No. HRB 737788</p>
        <p>VAT ID No.: DE 81 11 20 930</p>
    </div>

    <h3 class="text-2xl font-semibold mb-3">Legal Notes</h3>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-sm mb-6">

        <h4 class="text-lg font-semibold">Copyright</h4>
        <p>Copyright Mercedes-Benz Group AG. All rights reserved. All texts, images, graphics, audio, video, and
            animation files as well as their arrangements are subject to copyright and other intellectual property laws.
            They may not be copied for commercial purposes or distribution, nor modified or used on other websites.</p>

        <h4 class="text-lg font-semibold mt-3">Trademarks</h4>
        <p>Unless otherwise indicated, all marks displayed on Mercedes-Benz websites are subject to trademark rights,
            including model names and corporate logos and emblems.</p>

        <h4 class="text-lg font-semibold mt-3">Product and Pricing Information</h4>
        <p>Product and service changes may occur after editorial deadlines for individual pages. The manufacturer
            reserves the right to make changes to the design or form, deviations in color, and changes to the scope of
            delivery or service, provided these changes or deviations are reasonable for the customer, taking into
            account the interests of Mercedes-Benz.</p>

        <h4 class="text-lg font-semibold mt-3">Disclaimer</h4>
        <p>The information on these websites is provided "as is" and without warranty of any kind, either express or
            implied. This includes but is not limited to implied warranties of merchantability, fitness for a particular
            purpose, or non-infringement.</p>
    </div>
</div>
